export * from './common-error.component';
